var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-menu',{attrs:{"formats":['png', 'pdf', 'print', 'excel'],"loading-format":_vm.loading ? 'excel' : ''},on:{"export":_vm.handleExport}})
}
var staticRenderFns = []

export { render, staticRenderFns }